import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'react';

if(['production', 'staging'].includes(import.meta.env.VITE_ENV)) {
  Bugsnag.start({
    apiKey: 'ec89c58ba60c05f9b7db8b45dcf55a3e',
    plugins: [new BugsnagPluginReact(React)],
    releaseStage: import.meta.env.VITE_ENV || 'development',
  });
}
